import { useEffect, useState } from "react";
import API from "../../services/API/CRM";
import Layout from '../Frames/Layout'
import Grid from "../Tools/Grid";
import Top from "./Companies/Top";
import { Link } from "react-router-dom";
import { Checkbox, IconButton } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";

export default function Firms(){
    
    const columns = [
        {
            field: 'id',
            headerName: 'SIRET',
            width: 160,
            valueGetter: p => p.row.id
        },
        {
            field: 'name',
            headerName: 'Nom',
            width: 400,
            valueGetter: p => p.row.name
        },
        {
            field: 'users',
            headerName: 'Contacts',
            width: 100,
            type: 'number',
            valueGetter: p => p.row.users
        },
        {
            field: 'enrollments',
            headerName: 'Inscriptions',
            width: 100,
            type: 'number',
            valueGetter: p => p.row.enrollments
        },
        {
            field: 'revenue',
            headerName: 'CA €',
            width: 120,
            type: 'number',
            valueGetter: p => p.row.revenue,
        },
        {
            field: 'group',
            headerName: 'Groupement',
            width: 200,
            valueGetter: p => p.row.group?.name
        },
        {
            field: 'privatize',
            headerName: 'Privatisé',
            width: 80,
            type: 'boolean',
            valueGetter: p => p.row.privatize,
            renderCell: p => !p.rowNode.isAutoGenerated &&
                <Checkbox checked={p.value} disabled size='small' />
        },
        {
            field: 'update',
            headerName: '',
            width: 50,
            valueGetter: p => p.row.id,
            renderCell: p => !p.rowNode.isAutoGenerated &&
                <Link to={`/crm/firms/${p.value}`}>
                    <IconButton size='small'>
                        <Edit />
                    </IconButton>
                </Link>
        },
        {
            field: 'delete',
            headerName: '',
            width: 50,
            valueGetter: p => p.row.id,
            renderCell: p => !p.rowNode.isAutoGenerated &&
                <IconButton size='small' onClick={() => handleDelete(p.value)}>
                    <Delete />
                </IconButton>
        },
    ];

    const [items, setItems] = useState(null)

    useEffect(() => {

        API.getFirms()
            .then(r => setItems(r.data))
            .catch(e => console.log(e.response?.data))

    }, [])

    const handleDelete = id => {

        if( !window.confirm("Êtes-vous sûr de vouloir supprimer cette entreprise ?") ){
            return false;
        }

        const old = [...items];
        let copy = [...items];
        copy = copy.filter(i => i.id !== id);
        setItems(copy)

        API.deleteFirm(id).catch(e => setItems(old))
    }

    return <Layout tab='companies' menu='crm' title='Entreprises'>

        <Top />

        <Grid 
            id='firmsGrid'
            columns={columns}
            rows={items}
            toolbar
            aggregate={{users: 'sum', enrollments: 'sum', revenue: 'sum'}}
        />

    </Layout>

}


